module.exports = __webpack_public_path__ + "static/media/img122.a71d330f.jpg";